// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-heading h2[data-v-3270b675]{font-size:2.5rem;font-weight:700;margin-bottom:1rem;background:linear-gradient(135deg,#28a745,#20c997);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-align:center}.about-testimonial[data-v-3270b675]{background:linear-gradient(135deg,#28a745,#20c997);padding:60px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
